import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';

type InputProps = {
  menuId: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  stopPropagation?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
};

export const UiKebabMenu = ({
  className,
  menuId,
  children,
  disabled,
  icon,
  stopPropagation,
  size,
}: InputProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleMenuClose = (e: React.MouseEvent) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    setAnchorEl(null);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <IconButton
        className={className}
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleMenuClick}
        disabled={disabled}
        data-cy={menuId}
      >
        {icon || <MaterialDesignIcon iconName={ICON_NAMES.MORE_VERT} size={size || 'lg'} />}
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        PopoverClasses={{ root: 'u-zIndex-10000' }}
        keepMounted
      >
        {children}
      </Menu>
    </>
  );
};
